/**
 * BDA-5490 — IDs for Stiftung-Gesundheit Schwerpunkte (per the
 * BinDoc-SG Vertragsergänzung 30.03.2026).
 *
 * Mirrors the existing `medical-institution-type.ts` shape
 * (type union + values constant + display-name Record).
 */
export type BdSchwerpunkt =
  | 'endoskopien'
  | 'kapselendoskopie'
  | 'operationen-ambulant';

export const BD_SCHWERPUNKTE: BdSchwerpunkt[] = [
  'endoskopien',
  'kapselendoskopie',
  'operationen-ambulant',
];

export const BD_SCHWERPUNKT_DISPLAY_NAME: Record<BdSchwerpunkt, string> = {
  endoskopien: 'Endoskopien',
  kapselendoskopie: 'Kapselendoskopie',
  'operationen-ambulant': 'Operationen, ambulant',
};
